import React, { useEffect, useRef, useState } from 'react';
import logo from '../logo-mini.png';
const EmployeeHeader = ({ currentEmployee }) => {
  const [showPopup, setShowPopup] = useState(false);
  const buttonRef = useRef(null);
  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowPopup(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#f8f9fa',
        padding: '16px 24px',
        borderBottom: '1px solid #dee2e6',
        borderRadius: '6px',
        marginBottom: '24px',
        position: 'relative'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <img
          // src={currentEmployee.photo}
          src = {logo}
          alt="Profile"
          style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            objectFit: 'cover',
            border: '2px solid #dee2e6'
          }}
        />
        <div>
          <h4 style={{ margin: 0 }}>Welcome, {currentEmployee.name || 'Employee'}</h4>
          <small>ID: {currentEmployee.id || 'N/A'}</small>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', position: 'relative' }}>
        <div style={{ fontSize: '14px', color: '#6c757d' }}>
          {new Date().toLocaleDateString(undefined, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
        </div>

        <button
          ref={buttonRef}
          onClick={() => setShowPopup((prev) => !prev)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0
          }}
          aria-label="User menu"
        >
          <img
            src={logo}
            alt="User"
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              objectFit: 'cover',
              border: '2px solid #dee2e6',
            }}
          />
        </button>

        {showPopup && (
          <div
            ref={popupRef}
            style={{
              position: 'absolute',
              top: 'calc(100% + 10px)',
              right: 0,
              width: '220px',
              backgroundColor: 'white',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
              borderRadius: '8px',
              padding: '16px',
              zIndex: 999,
              fontSize: '14px',
              color: '#212529',
              userSelect: 'none',
            }}
          >
            <div style={{ marginBottom: '12px' }}>
              <strong>Name:</strong> {currentEmployee.name || 'N/A'}
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>ID:</strong> {currentEmployee.id || 'N/A'}
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Role:</strong> {currentEmployee.role || 'User'}
            </div>
            <button
              onClick={() => {
                sessionStorage.clear();
                window.location.href = '/login';
              }}
              style={{
                width: '100%',
                padding: '8px 0',
                backgroundColor: '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: '600',
                marginTop: '8px'
              }}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default EmployeeHeader;
